import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import { FAQButton } from '@/components/astro/new-design-25/ui/FAQ-Button';
import { Footer } from '@/components/astro/new-design-25/ui/Footer';
import { NavBar } from '@/components/astro/new-design-25/ui/NavBar';
import * as m from '@/paraglide/messages';
import { AdvantagesSection } from './advantages-section';
import { BentoSection } from './bento-section';
import { ComparisonSection } from './comparison-section';
import { FinalCtaSection } from './final-cta-section';
import { HeroSection } from './hero-section';
import { ScatteredAppsSection } from './scattered-apps';
import { TestimonialsSection } from './testimonials';

export function ComparePage() {
  return (
    <>
      <a
        className='sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4'
        href='#main-content'
      >
        {m.skip_to_main_content()}
      </a>
      <div className="bg-white font-(family-name:--v2-font) text-(--v2-text-primary) antialiased [--font-mono:'Geist_Mono_Variable',ui-monospace,monospace] [--v2-font:'Geist_Variable',ui-sans-serif,system-ui,sans-serif]">
        <NavBar ctaLabel={m.common_try_for_free()} showLinks={false} />
        <main id='main-content' tabIndex={-1}>
          <HeroSection />
          <ComparisonSection />
          <AdvantagesSection />
          <BentoSection />
          <ScatteredAppsSection />
          <TestimonialsSection />
          <FinalCtaSection />
          <FAQButton />
        </main>
        <Footer />
      </div>
    </>
  );
}
